import { Badge, Group, ScrollArea, Tabs, Text } from '@mantine/core';

import type { TH2HPaymentCounts, TH2HPaymentQueueTab } from '../store/types';

type Props = {
  value: TH2HPaymentQueueTab;
  counts: TH2HPaymentCounts;
  onChange: (value: TH2HPaymentQueueTab) => void;
};

const tabs: { value: TH2HPaymentQueueTab; title: string; count: keyof TH2HPaymentCounts }[] = [
  { value: 'all', title: 'Всё', count: 'all' },
  { value: 'action_required', title: 'Требует действия', count: 'actionRequired' },
  { value: 'awaiting_provider', title: 'Ожидает коллбэк', count: 'awaitingProvider' },
  { value: 'discrepancies', title: 'Расхождение', count: 'discrepancies' },
];

export const H2HPaymentTabs = ({ value, counts, onChange }: Props) => (
  <ScrollArea type="auto" offsetScrollbars mb="sm">
    <Tabs
      value={value}
      onChange={tab => tab && onChange(tab as TH2HPaymentQueueTab)}
    >
      <Tabs.List style={{ flexWrap: 'nowrap' }}>
        {tabs.map(tab => (
          <Tabs.Tab key={tab.value} value={tab.value}>
            <Group gap={6} wrap="nowrap">
              <Text span inherit>{tab.title}</Text>
              <Badge size="sm" variant="light" circle={counts[tab.count] < 100}>
                {counts[tab.count]}
              </Badge>
            </Group>
          </Tabs.Tab>
        ))}
      </Tabs.List>
    </Tabs>
  </ScrollArea>
);
